import { IRequestState } from "@app/types";

export interface IrequestState {
  getrequest: IRequestState;
  addrequest: IRequestState;
  addstatus: IRequestState;
  addvaluation: IRequestState;
  assignAgent: IRequestState;
  requestDetail: IRequestState;
  assignsalesperson: IRequestState;
  deleterequest: IRequestState;
  approveSellCar: IRequestState;
}
export interface IRequestsData {
  id: number;
}
export interface IGetRequestData {
  search: any;
  limit: number;
  page: number;
}

export const Header = [
  "Request Id",
  "Customer Name",
  "Car Model",
  "Type",
  "Date",
  "Status",
  "Action",
];